<div
  class="avatar"
  [ngClass]="[paletteClass$(), sizeClasses$().container]"
  [class.square]="shape() === 'square'"
  [class.basic]="style() === 'basic'"
  [class.light]="style() === 'light'"
  [class.transparent]="style() === 'transparent'"
>
  @if (svgIcon()) {
    <mat-icon class="avatar__content" [svgIcon]="svgIcon()"></mat-icon>
  } @else if (faIcon()) {
    <fa-icon class="avatar__content" [icon]="faIcon()"></fa-icon>
  } @else {
    <span class="avatar__content fw__600" [ngClass]="sizeClasses$().text">{{ initials$() }}</span>
  }
</div>
